import { useNavigate } from 'react-router-dom';
import useLoginContext from './useLoginContext';

/**
 * Custom hook to manage the state and logic for a header input field.
 * It supports handling input changes, executing a search on 'Enter' key press,
 * and managing user sign-out functionality.
 *
 * @returns {Object} An object containing:
 *   - val: The current value of the input field.
 *   - setVal: Function to update the input field value.
 *   - handleInputChange: Function to handle changes in the input field.
 *   - handleKeyDown: Function to handle 'Enter' key press and trigger a search.
 *   - handleSignOut: Function to handle user sign-out and navigation to the landing page.
 */
const useHeader = () => {
  const navigate = useNavigate();
  const { logout } = useLoginContext();

  /**
   * Signs the user out by calling the logout function and navigating to the landing page.
   */
  const handleSignOut = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      // Error handled silently, user is still navigated to login page
      navigate('/');
    }
  };

  return {
    handleSignOut,
  };
};

export default useHeader;
